import React from 'react';

// Rebuilt from the original Y.S.E Media logo (black square, slab "Y", wordmark) so it stays crisp at any size.
export default function Logo({ inverted = false, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span
        aria-hidden="true"
        className={`inline-flex size-8 items-center justify-center rounded-[3px] font-slab text-[1.35rem] font-extrabold leading-none ${
          inverted ? 'bg-paper text-ink' : 'bg-ink text-paper'
        }`}
      >
        Y
      </span>
      <span className={`text-lg font-normal tracking-[-0.04em] ${inverted ? 'text-paper' : 'text-ink'}`}>
        Y.S.E Media
      </span>
    </span>
  );
}
